import {DraggableTree} from 'vue-draggable-nested-tree'
import Status from '@/components/status'
import ViewDetail from '../group-document/view-detail'
import CreateChildren from '../group-document/create-child'
import EditGroup from '../group-document/edit'
import swal from 'sweetalert'
import ListDocument from '../list-document'
import AddRoot from '../group-document/create'

export default {
  name: 'list',
  components: {
    Tree: DraggableTree,
    Status,
    ViewDetail,
    CreateChildren,
    EditGroup,
    ListDocument,
    AddRoot
  },
  props: [],
  data () {
    return {
      select: {
        id: 0
      }
    }
  },
  computed: {
    data: {
      get () {
        return this.$store.getters['GroupDocument/getListGroupDocument']
      },
      set (value) {
        this.$store.commit('GroupDocument/getListGroupDocument', value)
      }
    },
    showEdit () {
      return this.$store.getters['Document/getOpenEdit']
    },
    showDocument () {
      return this.$store.getters['Document/getOpenDocument']
    },
    showCreateChildren () {
      return this.$store.getters['Document/getOpenCreateChildren']
    },
    showViewInfo () {
      return this.$store.getters['Document/getOpenView']
    },
    can_drop () {
      var permission = this.$store.getters['Profile/getPermission']
      const groupId = this.$store.getters['Profile/getGroup']
      return permission.indexOf(this.$permissions.UPDATE_ORGANIZATION) !== -1 || groupId === 1
    }
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('GroupDocument/getListGroupDocument', {page: 1, per_page: 'all'}),
      this.$store.dispatch('Status/getListStatus')
    ]).then(res => {
      this.select = this.data[0]
      this.$store.dispatch('Document/getListDocument', {page: this.page, per_page: this.per_page, status: this.status, search: this.search, sort: this.sort, group_id: this.select.id})
    }).catch(errors => {

    })
  },
  methods: {
    selected (group) {
      this.$store.dispatch('Document/getListDocument', {page: this.page, per_page: this.per_page, status: this.status, search: this.search, sort: this.sort, group_id: group.id}).then(res => {
        this.$store.dispatch('Document/openDocument')
        this.select = group
      }).catch(errors => {

      })
    },
    showView () {
      this.$store.dispatch('Document/openView')
    },
    showEditModal (group) {
      if (group) {
        this.$store.dispatch('Document/openEdit')
      }
    },
    showAddModal (group) {
      this.$store.dispatch('Document/openCreateChildren')
    },
    document (group) {
      if (group !== undefined) {
        this.$store.dispatch('Document/getListDocument', {page: this.page, per_page: this.per_page, status: this.status, search: this.search, sort: this.sort, group_id: group.id}).then(res => {
          this.$store.dispatch('Document/openDocument')
        }).catch(errors => {

        })
      }
    },
    destroy (group) {
      if (group) {
        swal({
          title: this.$t('notify.delete_comfirm'),
          icon: 'warning',
          buttons: true,
          dangerMode: true
        })
          .then((willDelete) => {
            if (willDelete) {
              this.$store.dispatch('GroupDocument/destroyGroupDocument', {
                group_document: group
              }).then(() => {
                this.select = this.data[0]
                this.$notify({
                  group: 'success',
                  title: this.$t('notify.notify'),
                  text: this.$t('notify.delete_success')
                })
              }).catch(errors => {
                console.log(errors)
              })
            }
          })
      }
    },
    showAddRootModal () {
      this.$refs.rootModel.show()
    },
    approval (group_document = {}) {
      this.$store.dispatch('GroupDocument/approvalGroupDocument', {
        group_document
      }).then(res => {
        group_document.status = res.status

        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        console.log(errors)
      })
    },

    rejection (group_document = {}) {
      this.$store.dispatch('GroupDocument/rejectGroupDocument', {
        group_document
      }).then(res => {
        group_document.status = res.status

        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {

      })
    },
    createSuccess () {

    },
    updataSuccess () {

    },
    ondrag (node) {
      if (node.parent.id !== undefined) {
        node.parent_id = node.parent.id
      } else {
        node.parent_id = 0
      }
      this.group_document = {}
      this.group_document.parent_id = node.parent_id
      this.group_document.id = node.id
      this.group_document.name = node.name

      this.$store.dispatch('GroupDocument/updateGroupDocument', {group_document: this.group_document}).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {

      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/document/list/list.js